import { useMutation } from "@tanstack/react-query";
import { api } from "../../libs/axios";
import { formCartaoCredito } from "../../schemas/cartaoCredito";

export function useMutationCartao(id: string) {
  return useMutation({
    mutationFn: async (dados: formCartaoCredito) => {
      const response = await api.post(`/checkout/cartao`, {
        id,
        nome_titular: dados.nome,
        cpf_titular: dados.cpf,
        numero_cartao: dados.numero_cartao,
        cvv_cartao: dados.cvv_cartao,
        mes_cartao: dados.mes_cartao,
        ano_cartao: dados.ano_cartao,
        parcelas: dados.parcelas,
      });

      return response.data;
    },
  });
}
